import {
  makeHeaderNavigationSticky,
  eventListenerAddExpandMenu,
  eventListenerClickyMenuBtn,
  eventListenerNavButton,
} from "./layout/_layout__header-navigation";
import { eventListenerSubpageMenuBtn, initSubpageMenu } from "./layout/_layout__inner-navigation";
import { eventListenerOnScroll } from "./components/_comp__on-scroll-change";
import { eventListenerDropButton } from "./components/_comp__block--linklistblock";
import { eventListenerCloseBlock } from "./components/_comp__block--linklistblock";
import { multiItemCarousel } from "./components/_comp__block-multi-item-carousel";
import { dropdownInArticle } from "./components/_comp__dropdownInArticle";
import { dropDownToggle } from "./components/_comp__block--dropdowntoggle";
import { stopMailLinksAndOpenEmail } from "./components/_comp__mail-current-page";
import { scrollHorizontally } from "./components/_comp__block--horizontal-scroll";
import { autoComplete } from "./components/_comp__autocomplete";
import { updateSearchResults } from "./components/_comp__updateSearchResults";


initSubpageMenu();
makeHeaderNavigationSticky();
eventListenerAddExpandMenu();
eventListenerClickyMenuBtn();
eventListenerNavButton();
eventListenerOnScroll();
eventListenerCloseBlock();
multiItemCarousel();
dropDownToggle();
dropdownInArticle();
stopMailLinksAndOpenEmail();
scrollHorizontally();
autoComplete();
updateSearchResults();

if (!document.querySelector(".page-type--startPage")) { eventListenerSubpageMenuBtn(); }
//if (document.querySelector("#subpageNavigation")) { eventListenerSubpageMenuBtn(); }
if (document.querySelector(".drop-chooser__btn")) { eventListenerDropButton(); }

//const el = document.querySelector('.block.dropdown');
//el.onclick = () => el.classList.toggle('dropped');


